var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t_footer"},[_c('h3',[_vm._v("Copyright © 2020-2022 东莞云百科技有限公司版权所有 Power by yunbai")]),_c('h3',[_vm._v("ICP备案号：粤ICP备17032472号")])])
}]

export { render, staticRenderFns }